module.exports = __webpack_public_path__ + "static/media/w (21).56bf4b36.jpg";